import {
  useReactTable,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  getFilteredRowModel,
} from "@tanstack/react-table";
import { useState } from "react";
import PropTypes from "prop-types";

export default function TanStackTable({ data, columns, filtering, setFiltering }) {
  const [sorting, setSorting] = useState([]);

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: { sorting, globalFilter: filtering },
    onSortingChange: setSorting,
    onGlobalFilterChange: setFiltering,
  });

  const pageIndex = table.getState().pagination.pageIndex; 
  const pageSize = table.getState().pagination.pageSize; 
  const totalRows = data.length; 
  const totalPages = table.getPageCount(); 

  const startItem = pageIndex * pageSize + 1;
  const endItem = Math.min((pageIndex + 1) * pageSize, totalRows);

  return (
    <div>
      <table className="table table-sm fs-9 mb-0">
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id} className="bg-body-highlight">
              {headerGroup.headers.map((header) => (
                <th
                  className="sort align-middle pe-5"
                  scope="col"
                  data-sort="customer"
                  style={{ width: "20%" }}
                  key={header.id}
                  onClick={header.column.getToggleSortingHandler()}
                >
                  {header.isPlaceholder ? null : header.column.columnDef.header}
                  {header.column.getIsSorted() === "asc"
                    ? "⬆️"
                    : header.column.getIsSorted() === "desc"
                    ? "⬇️"
                    : null}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody className="list">
          {table.getRowModel().rows.map((row) => (
            <tr
              key={row.id}
              className="hover-actions-trigger btn-reveal-trigger position-static"
            >
              {row.getVisibleCells().map((cell) => (
                <td key={cell.id} className="align-middle">
                  {cell.column.columnDef.cell
                    ? cell.column.columnDef.cell(cell)
                    : cell.getValue()}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <div className="d-flex justify-content-between align-items-center mt-4 mb-3 position-relative">
        <p className="mb-0 fs-9">
          <span className="d-none d-sm-inline-block">
            {startItem} a {endItem}
            <span className="text-body-tertiary"> Elementos de </span>
            {totalRows}
          </span>
        </p>

        <div className="d-flex position-absolute start-50 translate-middle-x">
          <button
            className="page-link btn btn-subtle-secondary me-1 mb-1"
            type="button"
            onClick={() => table.setPageIndex(0)}
            disabled={!table.getCanPreviousPage()}
          >
            <span className="fas fa-angle-double-left"></span>
          </button>
          <button
            className="page-link btn btn-subtle-primary me-1 mb-1"
            type="button"
            onClick={() => table.previousPage()}
            disabled={!table.getCanPreviousPage()}
          >
            <span className="fas fa-chevron-left"></span>
          </button>
          <button
            className="page-link btn btn-subtle-primary me-1 mb-1"
            type="button"
            onClick={() => table.nextPage()}
            disabled={!table.getCanNextPage()}
          >
            <span className="fas fa-chevron-right"></span>
          </button>
          <button
            className="page-link btn btn-subtle-secondary me-1 mb-1"
            type="button"
            onClick={() => table.setPageIndex(table.getPageCount() - 1)}
            disabled={!table.getCanNextPage()}
          >
            <span className="fas fa-angle-double-right"></span>
          </button>
        </div>

        <p className="mb-0 fs-9">
          Pagina {pageIndex + 1} de {totalPages}
        </p>
      </div>
    </div>
  );
}

TanStackTable.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  filtering: PropTypes.string,
  setFiltering: PropTypes.func,
};
